import { Component, OnInit, ViewChild } from '@angular/core';
import { Product } from '../shared/misc-classes';
import { DataService } from '../shared/dataservice.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-rtc-uploader',
  templateUrl: './rtc-uploader.component.html',
  styleUrls: ['./rtc-uploader.component.css']
})
export class RtcUploaderComponent implements OnInit {
  @ViewChild(FileUploadComponent) fileUploadComponent: FileUploadComponent;
  
  public uploader: FileUploader = new FileUploader({ url: '/uploadprodfile' });

  _uploadProductList:Array<Product> = [];

  selRTCFolder:string = "";

  constructor(private _dataService: DataService) { }

  ngOnInit() {
    this._uploadProductList = this._dataService.uploadProductList;
    
  }

  ProductSelected(){
    console.log(this.selRTCFolder);
    this.fileUploadComponent.update(this.selRTCFolder, this.uploader);
  }
  prodSelected(_evnt){
    console.log(_evnt);
  }

}
